export default __webpack_public_path__ + "static/media/check-mark.0a7ad812.svg";